import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";
import FeatureRegistry from "@features/FeatureRegistry";

// Get feature registry instance
const featureRegistry = new FeatureRegistry();

// Initialize UI with feature UI components
import("./main.app.ui").then(({ initUI }) => {
  initUI(featureRegistry.getFeatureUIs());
});

// Initialize app with feature controllers when UI is ready
emitter.on("ui-ready", () => {
  import("./main.app").then(({ initApp }) => {
    initApp(featureRegistry.getFeatureControllers());
  });
});

//----------------------------------------------------------------

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}